module.exports = __webpack_public_path__ + "static/img/img-wikipedia_banner.089f2c39.jpeg";